import { observer } from 'mobx-react'
import { Fragment, useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import ContentState from '../../../../stores/ContentState'
import GlobalState from '../../../../stores/GlobalState'
import CustomSlider from '../../../common/CustomSlider'
import './index.scss'

const CountryList = observer(() => {
  const [countries, setCountries] = useState<any>(null)
  const [width, setWidth] = useState(window.innerWidth)

  const getCountries = async () => {
    try {
      const fd = new FormData()
      fd.append('lang', GlobalState.currentLocale.lang)
      fd.append('status', 'carrer-flag-list')

      const request = await fetch(GlobalState.domain, {
        method: 'POST',
        body: fd,
      })

      const response = await request.json()

      setCountries(response)
      setTimeout(() => {
        document.querySelector('.career-country__inner')
        document.querySelectorAll('.career-country__inner').forEach((c) => {
          c?.classList.add('anim')
        })
      }, 0)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getCountries()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  const getMiddle = (arr: any) => {
    if (!arr) return 0
    return Math.floor((arr.length - 1) / 2)
  }

  if (!countries) return <></>
  return (
    <section className="career-country">
      <div className="career-country__title">
        {ContentState.career.countries.title}
      </div>
      <div className="career-country__list">
        <div className="career-country__inner">
          {countries
            .slice(
              0,
              width > 576 ? countries?.length || 0 : getMiddle(countries),
            )
            ?.map((c: any, i: number) => (
              <div
                className="career-country__item"
                key={i}
                onMouseEnter={() => {
                  if (!isMobile) {
                    document
                      .querySelectorAll('.career-country__inner')
                      .forEach((c) => {
                        c?.classList.remove('anim')
                        c?.classList.add('stop')
                      })
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    document
                      .querySelectorAll('.career-country__inner')
                      .forEach((c) => {
                        c?.classList.remove('stop')
                        c?.classList.add('anim')
                      })
                  }
                }}
              >
                <div className="career-country__item-img">
                  <img src={c.icon} />
                </div>
                <div className="career-country__item-text">{c.text}</div>
              </div>
            ))}
          {countries
            .slice(
              0,
              width > 576 ? countries?.length || 0 : getMiddle(countries),
            )
            ?.map((c: any, i: number) => (
              <div
                className="career-country__item"
                key={i}
                onMouseEnter={() => {
                  if (!isMobile) {
                    document
                      .querySelectorAll('.career-country__inner')
                      .forEach((c) => {
                        c?.classList.remove('anim')
                        c?.classList.add('stop')
                      })
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    document
                      .querySelectorAll('.career-country__inner')
                      .forEach((c) => {
                        c?.classList.remove('stop')
                        c?.classList.add('anim')
                      })
                  }
                }}
              >
                <div className="career-country__item-img">
                  <img src={c.icon} />
                </div>
                <div className="career-country__item-text">{c.text}</div>
              </div>
            ))}
          {countries
            .slice(
              0,
              width > 576 ? countries?.length || 0 : getMiddle(countries),
            )
            ?.map((c: any, i: number) => (
              <div
                className="career-country__item"
                key={i}
                onMouseEnter={() => {
                  if (!isMobile) {
                    document
                      .querySelectorAll('.career-country__inner')
                      .forEach((c) => {
                        c?.classList.remove('anim')
                        c?.classList.add('stop')
                      })
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    document
                      .querySelectorAll('.career-country__inner')
                      .forEach((c) => {
                        c?.classList.remove('stop')
                        c?.classList.add('anim')
                      })
                  }
                }}
              >
                <div className="career-country__item-img">
                  <img src={c.icon} />
                </div>
                <div className="career-country__item-text">{c.text}</div>
              </div>
            ))}
        </div>
        <div className="career-country__inner">
          {countries
            .slice(getMiddle(countries), countries?.length)
            ?.map((c: any, i: number) => (
              <div
                className="career-country__item"
                key={i}
                onMouseEnter={() => {
                  if (!isMobile) {
                    document
                      .querySelectorAll('.career-country__inner')
                      .forEach((c) => {
                        c?.classList.remove('anim')
                        c?.classList.add('stop')
                      })
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    document
                      .querySelectorAll('.career-country__inner')
                      .forEach((c) => {
                        c?.classList.remove('stop')
                        c?.classList.add('anim')
                      })
                  }
                }}
              >
                <div className="career-country__item-img">
                  <img src={c.icon} />
                </div>
                <div className="career-country__item-text">{c.text}</div>
              </div>
            ))}
        </div>
      </div>
    </section>
  )
})

export default CountryList
